import { localizePathname } from "@/lib/locale-routing"

export const TRACKED_APP_DOWNLOAD_URL = "https://url.yohomobile.com/dO6zZ"
export const APP_STORE_URL = "https://apps.apple.com/us/app/id6670394055"
export const CHINA_APP_STORE_URL = "https://apps.apple.com/cn/app/id6670394055"
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.yohomobile.yoho_esim"
export const APP_LANDING_PATH = "/downloadapp"
export const APPLE_ESIM_SETUP_URL = "https://support.apple.com/en-us/118669"
export const SAMSUNG_ESIM_SETUP_URL = "https://www.samsung.com/us/support/answer/ANS10001619/"

export type OfficialInstallGuide = {
  href: string
  label: string
  shortLabel: string
}

export function getAppLandingHref(lng: string): string {
  return localizePathname(APP_LANDING_PATH, lng)
}

export function getAppStoreUrl(lng: string): string {
  return lng === "zh-CN" ? CHINA_APP_STORE_URL : APP_STORE_URL
}

export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href)
}

export function getOfficialInstallGuides(lng: string): OfficialInstallGuide[] {
  const isZh = lng === "zh-CN"

  return [
    {
      href: APPLE_ESIM_SETUP_URL,
      label: isZh ? "Apple 官方 iPhone eSIM 设置" : "Apple official iPhone eSIM setup",
      shortLabel: isZh ? "iPhone 指南" : "iPhone guide",
    },
    {
      href: SAMSUNG_ESIM_SETUP_URL,
      label: isZh ? "Samsung 官方 Galaxy eSIM 设置" : "Samsung official Galaxy eSIM setup",
      shortLabel: isZh ? "Samsung 指南" : "Samsung guide",
    },
  ]
}
